import { IconMailForward, IconUserPlus, IconUsers } from "@tabler/icons-react"
import { type FC, useState } from "react"

import Button from "~/components/Button"
import Layout, { PageHeader, PageHeaderGroup, PageTitle } from "~/components/Layout"
import LoadingError from "~/components/LoadingError"
import PartialLoadingPage from "~/components/PartialLoadingPage"
import { query } from "~/utilities/trpc"

import InvitedUsers from "./InvitedUsers"
import InviteUsersModal from "./InviteUsersModal"
import Stats from "./Stats"
import Users from "./Users"

const UsersPage: FC = () => {
	const [isInviteUsersOpen, setInviteUsersOpen] = useState(false)

	const users = query.platform.listUsers.useQuery()
	const invitedUsers = query.platform.listInvitedUsers.useQuery()

	return (
		<Layout>
			<InviteUsersModal
				isOpen={isInviteUsersOpen}
				onClose={() => {
					setInviteUsersOpen(false)
					invitedUsers.refetch()
				}}
			/>
			<PageHeader>
				<PageTitle>Users</PageTitle>
				<PageHeaderGroup>
					<Button variant="primary" onClick={() => setInviteUsersOpen(true)}>
						<IconUserPlus className="size-4" aria-hidden="true" /> Invite users
					</Button>
				</PageHeaderGroup>
			</PageHeader>
			{users.error && users.data === undefined ? (
				<LoadingError subject="users" error={users.error} onRetry={users.refetch} />
			) : users.data === undefined ? (
				<PartialLoadingPage />
			) : users.data.length === 0 ? (
				<div className="border-component-border flex flex-col items-center rounded-3xl border bg-white px-6 py-12 text-center">
					<div className="bg-component-background mb-4 rounded-2xl p-3">
						<IconUsers className="size-6 text-gray-500" aria-hidden="true" />
					</div>
					<h2 className="font-semibold">No users yet</h2>
					<p className="mt-2 max-w-md text-sm leading-relaxed text-gray-500">
						Users appear here as soon as they sign up to your academy. Share your academy link, or invite
						your existing audience by email to get started.
					</p>
					<Button variant="secondary" onClick={() => setInviteUsersOpen(true)} className="mt-6">
						<IconMailForward className="size-4" aria-hidden="true" /> Invite users
					</Button>
				</div>
			) : (
				<div className="space-y-8">
					<Stats users={users.data} />
					<Users users={users.data} />
				</div>
			)}
			{invitedUsers.error && invitedUsers.data === undefined ? (
				<section className="mt-10 space-y-4">
					<h2 className="text-lg font-semibold">Pending invites</h2>
					<LoadingError subject="invites" error={invitedUsers.error} onRetry={invitedUsers.refetch} />
				</section>
			) : invitedUsers.data !== undefined && invitedUsers.data.length > 0 ? (
				<InvitedUsers invites={invitedUsers.data} />
			) : null}
		</Layout>
	)
}

export default UsersPage
